export default __webpack_public_path__ + "static/media/Grupo_352.e65d64b0.svg";